import _ from 'underscore';
import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'


export default {
	name: 'partnerinfo',
	props: {
		scroll : Number,
		userid : Number,
		mode : String
	},

	components : {
	},

	data : function(){

		return {
			loading : false,
			error : null,
			paymentInfoFieldsValues : {},
			infoFieldsValues : {},

			infoFill : false,
			veriefied : false,
			
		}

	},

	created() {

		this.load()

	},

	destroyed() {
	},

	watch: {
		tscrolly : function(){
		}
	},
	computed: mapState({
		tscrolly : function(state){
			return this.scroll || state.tscrolly
		},
		auth : state => state.auth,
		userinfo : state => state.userinfo?.userinfo,
		cuserid : function(){
			return this.userid || this.userinfo.id
		},

		сountries : function(){
			return f.deep(this.core, 'appInfo.promo.сountries') || []
		},

		viewmode : function(){
			if(this.mode == 'team') return true

			return false
		},

		infoFields : function(){
			return [
				{
                    id: 'country',
                    input: 'select',
                    text: 'partner.сountry',
                    values : _.map(this.сountries, (сountry) => {
                        return {
                            value : сountry,
                            text : "сountries." + сountry
                        }
                    }),
					rules : [{
                        rule : 'required'
                    }]
                },
				{
                    id : 'firstName',
                    text : 'fields.FName',
                    rules : [{
                        rule : 'required'
                    }]
                },
                {
                    id : 'lastName',
                    text : 'fields.LName',
                    rules : [{
                        rule : 'required'
                    }]
                },

				{
                    id : 'email',
                    text : 'fields.Email',
                    rules : [{
                        rule : 'required'
                    },{
                        rule : 'email'
                    },{
                        rule : 'min:5'
                    }]
                },

				{
                    id : 'phone',
                    text : 'fields.Phone',
                    rules : [{
                        rule : 'required'
                    },{
                        rule : 'phone'
                    },{
                        rule : 'min:5'
                    }]
                },
				{
                    id : 'social',
                    text : 'partner.social',
                    rules : [{
                        rule : 'required'
                    }]
                },
			]
		},

		paymentInfoFields : function(){

			if(this.infoFieldsValues && this.infoFieldsValues.country == 'ru'){

				var statuses = ['ie', 'se', 'in']

				return [
					{
						id: 'status',
						input: 'select',
						text: 'partner.status',
						values : _.map(statuses, (status) => {
							return {
								value : status,
								text : "partner.statuses." + status
							}
						}),
						rules : [{
							rule : 'required'
						}]
					},

					{
						id : 'inn',
						text : 'partner.inn',
						rules : [{
							rule : 'required'
						},{
							rule : 'min:10'
						},{
							rule : 'max:12'
						}]
					},
					{
						id : 'ogrn',
						text : 'partner.ogrn',
						rules : []
					},
					{
						id : 'bankname',
						text : 'partner.bankname',
						rules : [{
							rule : 'required'
						}]
					},
					{
						id : 'bic',
						text : 'partner.bic',
						rules : [{
							rule : 'required'
						},{
							rule : 'min:7'
						},{
							rule : 'max:10'
						}]
					},
					{
						id : 'account',
						text : 'partner.account',
						rules : [{
							rule : 'required'
						},{
							rule : 'min:20'
						},{
							rule : 'max:20'
						}]
					},
					{
						id : 'corr',
						text : 'partner.corr',
						rules : [{
							rule : 'required'
						},{
							rule : 'min:20'
						},{
							rule : 'max:20'
						}]
					},
				]
			}
			else{
				return []
			}

			
		}
		
	}),

	methods : {
		save : function(){

			var infoFieldsValues = this.$refs['infoFields'].get()
			var paymentInfoFieldsValues = this.$refs['paymentInfoFields'].get()

			if (infoFieldsValues && paymentInfoFieldsValues){

				this.verifiedQuestion().then(() => {

					var promise = null

					var payload = {
						userid : this.cuserid,
						paymentinfo : paymentInfoFieldsValues,
						info : infoFieldsValues
					}

					if(this.mode == 'team') promise = this.core.api.team.partner.updateInfo(payload)
					else promise = this.core.api.partner.updateInfo(payload)


					return this.core.promwrapper(promise)

				}).then(() => {
					this.load()
				}).catch( e => {
				
				})

			}

			//this.load()
		},

		verifiedQuestion : function(){
			if(!this.veriefied){
				return Promise.resolve()
			}

			return this.$dialog.confirm(
				this.$t('partner.verifyChangeData'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				return Promise.resolve()
				
			})
		},

		load : function(){
			var promise = null

			if(this.mode == 'team') promise = this.core.api.team.partner.getInfo(this.cuserid)
			else promise = this.core.api.partner.getInfo(this.cuserid)

			this.loading = true

			promise.then((data) => {

				this.infoFill = true

				this.veriefied = data.veriefied

				this.paymentInfoFieldsValues = data.paymentinfo
				this.infoFieldsValues = data.info

				this.error = null

			}).catch(e => {

				console.log("E", e)

				if(e?.error == 'empty'){

				}
				else{
					this.error = e
				}

				
			}).finally(() => {
				this.loading = false
			})
		},

		inputInfo : function(v){
			this.infoFieldsValues = v
			
		},

		inputPaymentInfo : function(v){
			this.paymentInfoFieldsValues = v
		},

		verifycancel : function(){
			this.$dialog.confirm(
				this.$t('partner.tverifycancelQ'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {
				this.promwrapper(this.core.api.team.partner.unverify(this.cuserid)).then(() => {
					this.load()
				})
				//this.promwrapper(this.core.api.moderation.approve(this.uid))
			}).catch( e => {
				
			})
		},

		verify: function(){
			this.$dialog.confirm(
				this.$t('partner.tverifyQ'), {
				okText: this.$t('yes'),
				cancelText : this.$t('no')
			})
	
			.then((dialog) => {

				this.promwrapper(this.core.api.team.partner.verify(this.cuserid)).then(() => {
					this.load()
				})

			}).catch( e => {
				
			})
		},

		
	},
}